import { Fragment, useContext } from "react";
import { Context } from "../context";
import GoogleAd from "./GoogleAd";
import { pageStyle, smallFont, mediumFont, largeFont, xLargeFont } from "../utils/styles";

const ContentBody = ({ __html, ad = "leaderboard_lazy" }) => {
  const { theme } = useContext(Context);

  const insertAds = (text, ad = "leaderboard_lazy") => {
    const texts = text.split("<ad>");

    return texts.map((txt, idx) => (
      <Fragment key={idx}>
        <div dangerouslySetInnerHTML={{ __html: `${txt.replace(/\s*$/, "")}` }} />
        {idx < texts.length - 1 && <GoogleAd section={ad} />}
      </Fragment>
    ));
  };

  return (
    <>
      <style jsx global>
        {`
          .embed-container {
            position: relative;
            padding-bottom: 56.25%;
            height: 0;
            overflow: hidden;
            max-width: 100%;
          }
          .embed-container iframe,
          .embed-container object,
          .embed-container embed {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }
        `}
      </style>
      <style jsx>{pageStyle}</style>
      <style jsx>
        {`
          .content {
            text-align: left;
          }
          .content :global(p) {
            font-size: ${smallFont};
            line-height: 160%;
            margin: 1rem 0;
          }
          .content > :global(p:first-child) {
          }
          .content > :global(p:first-child)::first-letter {
            font-size: 4.5rem;
            margin-top: 0.25em;
            margin-right: 0.25rem;
            color: ${theme.accentTextColor};
            float: left;
          }
          .content :global(.markdown-h1) {
            color: ${theme.accentTextColor};
            font-weight: bold;
            font-size: ${xLargeFont};
            line-height: 125%;
            margin: 1.5rem 0;
          }
          .content :global(h2) {
            color: ${theme.accentTextColor};
            font-weight: bold;
            font-size: ${largeFont};
            line-height: 125%;
            margin: 1.5rem 0;
          }
          .content :global(h3) {
            color: ${theme.emphasisTextColor};
            font-weight: bold;
            font-size: ${mediumFont};
            line-height: 125%;
            margin: 1.5rem 0;
            text-transform: uppercase;
          }

          .content :global(blockquote) {
            margin: 0;
            padding: 0;
            padding: 2rem;
            position: relative;
            margin-bottom: 1.5rem;
          }
          .content :global(blockquote:after) {
            line-height: 0;
            color: ${theme.accentTextColor};
            content: "”";
            position: absolute;
            font-family: serif;
            font-size: 5rem;
            right: 2rem;
            bottom: 0;
          }
          .content :global(blockquote:before) {
            line-height: 0;
            color: ${theme.accentTextColor};
            content: "“";
            position: absolute;
            font-family: serif;
            font-size: 5rem;
            left: 0;
            top: 2rem;
          }
          .content :global(blockquote p) {
            font-size: ${largeFont};
            font-weight: bold;
            line-height: 125%;
            margin: 0;
            padding: 0;
          }
          .content :global(a) {
            text-decoration: underline;
            text-underline-position: under;
            color: ${theme.accentTextColor};
          }
          .content :global(li) {
            margin-bottom: 2rem;
          }
          .content :global(ol) {
            list-style-type: decimal;
            padding-left: 2rem;
          }
          .content :global(ul) {
            padding-left: 1rem;
          }

          .content :global(hr) {
            border: none;
            border-bottom: 1px solid ${theme.borderColor};
            padding: 0;
            margin: 1.5rem 0;
            height: 0;
          }
        `}
      </style>
      <div className="content">{insertAds(__html, ad)}</div>
    </>
  );
};

export default ContentBody;
